import $ from 'jquery';
(function(){
    'use strict';

    var $sideNavToggleBtn = $('button.side-navigation__list-toggle');

    $sideNavToggleBtn.on('click', function () {
        var $clickedButton = $(this);
        var $sideNavAccordion = $clickedButton.closest('.has-children');
        if (!$sideNavAccordion.hasClass('active')) {
            $sideNavAccordion.addClass('active');
            $clickedButton.addClass('active');
        } else {
            $sideNavAccordion.removeClass('active');
            $clickedButton.removeClass('active');
        }
        return false;
    });

}());
